import React, { useState, Suspense } from 'react';

import MainView from './components/MainView';
import Registerlayout from '../components/Registerlayout';
import '../../../generalStyles.css';

const Casino = () => {
  const [view, setView] = useState<number>(0);

  return (
    <>
      {view === 0 && <MainView setView={setView} />}
      {view === 1 && (
        <Suspense fallback={null}>
          <Registerlayout view="casino" />
        </Suspense>
      )}
    </>
  );
};

export default Casino;
